import React, { useEffect, Children, memo } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
export function Conditions() {
  useEffect(() => {
    document.title = 'Conditions - Ari OS';
  }, []);
  return <div className="w-full min-h-screen bg-black relative overflow-hidden" data-id="element-673" data-mp="1hsn3hma2d8y">
      {/* Background - matching marketing page style */}
      <div className="fixed inset-0 z-0" data-id="element-674" data-mp="3spoeer6kkasc">
        <div className="absolute inset-0 bg-gradient-to-br from-zinc-950 via-black to-zinc-900" data-id="element-675" data-mp="3smiq3e5rlcxo"></div>
        <div className="absolute inset-0 opacity-30" data-id="element-676" data-mp="p7n1w4q5qbvu">
          <div className="absolute top-1/4 left-1/4 w-[600px] h-[600px] bg-[#E9A165] rounded-full blur-3xl opacity-20 animate-pulse-slow" data-id="element-677" data-mp="p8y4i17v9dld"></div>
          <div className="absolute top-1/3 right-1/4 w-[500px] h-[500px] bg-[#8846DE] rounded-full blur-3xl opacity-20 animate-pulse-slow" style={{
          animationDelay: '1s'
        }} data-id="element-678" data-mp="f9h1jrk01dt3"></div>
          <div className="absolute bottom-1/4 left-1/3 w-[550px] h-[550px] bg-[#D25796] rounded-full blur-3xl opacity-20 animate-pulse-slow" style={{
          animationDelay: '2s'
        }} data-id="element-679" data-mp="34weplfnvhtaw"></div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-white/[0.02] via-transparent to-transparent" data-id="element-680" data-mp="d9ssxgn5s3yk"></div>
      </div>

      {/* Content */}
      <div className="relative z-10" data-id="element-681" data-mp="3uheiq2us2iim">
        {/* Header */}
        <header className="border-b border-zinc-800 bg-zinc-950/80 backdrop-blur-xl" data-id="element-682" data-mp="3bdcc7lrcd3b">
          <div className="max-w-4xl mx-auto px-6 py-6" data-id="element-683" data-mp="3lq5sxgmsgbvr">
            <a href="/" className="inline-flex items-center space-x-2 text-zinc-400 hover:text-white transition-colors group" data-id="element-684" data-mp="3lob3bp0knvlc">
              <ArrowLeftIcon size={20} className="group-hover:-translate-x-1 transition-transform" data-id="element-685" data-mp="3qifhas8993vx" />
              <span data-id="element-686" data-mp="3bpvgvzchpai6">Back to Home</span>
            </a>
          </div>
        </header>

        {/* Main Content */}
        <main className="max-w-4xl mx-auto px-6 py-16" data-id="element-687" data-mp="32ra0oauhq7kk">
          <div className="bg-gradient-to-br from-zinc-900/50 to-zinc-950/50 backdrop-blur-xl rounded-2xl border border-zinc-800 p-8 md:p-12" data-id="element-688" data-mp="32rthfo8empx0">
            {/* Title */}
            <div className="mb-12" data-id="element-689" data-mp="1daxxnv3qwe6c">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-690" data-mp="1dbzaa40et8q6">
                Privacy Policy – Ari
              </h1>
              <p className="text-zinc-400" data-id="element-691" data-mp="13jthwt68wpag">Last Updated: 21 November 2025</p>
            </div>

            {/* Content */}
            <div className="space-y-10" data-id="element-692" data-mp="ym1h19nmhsu4">
              {/* Privacy Commitment */}
              <section data-id="element-693" data-mp="1w9a7lj2hds2z">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-694" data-mp="1w7fmo4r7lzyw">
                  Privacy Commitment
                </h2>
                <p className="text-zinc-300 leading-relaxed" data-id="element-695" data-mp="1ragrdivt7mz4">
                  Ari takes the protection of your privacy and personal data
                  very seriously and are committed to protecting your personal,
                  confidential, and otherwise sensitive information. We aspire
                  to conduct business and process your Data in accordance with
                  all applicable data protection legislation, in all markets
                  within which we operate.
                </p>
              </section>

              {/* Scope */}
              <section data-id="element-696" data-mp="2mjss1q0eonlq">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-697" data-mp="2mj0xmiijovx1">
                  Scope of the Ari Privacy Policy
                </h2>
                <p className="text-zinc-300 leading-relaxed" data-id="element-698" data-mp="2w8appyde2el5">
                  This Privacy Policy explains how Ari (hereinafter "Ari" "we",
                  "us", "our"), processes your Personal Data in connection with
                  your use of Ari products and services including the Ari
                  Operating System; Ari Cloud platform; Ari Business Cloud
                  platform; the Ari Companion App; Ari Website including Ari
                  Marketplace and the Ari Web Portal; and use of our Ari AI
                  Assistant that may be accessed by you as part of your use of
                  any of the foregoing platforms, either from a computer or an
                  augmented reality ("AR") device, head-mounted displays, or
                  similar hardware device (collectively the "Service").
                </p>
              </section>

              {/* Definitions */}
              <section data-id="element-699" data-mp="zhyb818u03iy">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-700" data-mp="zgdcdzfhhyfa">
                  Definitions
                </h2>
                <div className="space-y-4" data-id="element-701" data-mp="uiv7ql8i25d3">
                  <div data-id="element-702" data-mp="6shkr94ruwpd">
                    <p className="text-zinc-300 leading-relaxed" data-id="element-703" data-mp="6tsoxa24q6h0">
                      <strong className="text-white" data-id="element-704" data-mp="1to457u6upkz">"Ari AI Assistant"</strong>{' '}
                      means our artificial intelligence ("AI") software that
                      processes voice and/or text input, forwards it to AI
                      infrastructure (such as automatic speech recognition,
                      large language models and text-to-speech services), and
                      returns responses depending on your settings and your
                      organization's configuration as more particularly
                      described in Section 2.2 below.
                    </p>
                  </div>
                  <div data-id="element-705" data-mp="1zia2kvvyepzm">
                    <p className="text-zinc-300 leading-relaxed" data-id="element-706" data-mp="1zijn43y8c4xx">
                      <strong className="text-white" data-id="element-707" data-mp="1ktdpgkf1ims5">
                        "Data" or "Personal Data"
                      </strong>{' '}
                      collectively means all information that you submit in
                      order to access the Service and any Data collected through
                      Ari AI Assistant as set forth in Section 2.2 below.
                    </p>
                  </div>
                  <div data-id="element-708" data-mp="24fs5o5naiazp">
                    <p className="text-zinc-300 leading-relaxed" data-id="element-709" data-mp="24iebo0uj8ift">
                      <strong className="text-white" data-id="element-710" data-mp="28gls0ul33hqh">"Cookies"</strong> means a
                      small data file that is stored on your device and contains
                      data such as your personal site settings and log-in
                      information.
                    </p>
                  </div>
                  <div data-id="element-711" data-mp="2zondgk4cgkvp">
                    <p className="text-zinc-300 leading-relaxed" data-id="element-712" data-mp="2zr9jgfbl6sbt">
                      <strong className="text-white" data-id="element-713" data-mp="2uqu79r31jqvf">
                        "User," "You" or "Your"
                      </strong>{' '}
                      means you or any third party you authorize to access the
                      Service and is not either (i) employed by Ari and acting
                      in the course of their employment or (ii) engaged as a
                      consultant or otherwise providing services to Ari and
                      accessing the website in connection with the provision of
                      such services.
                    </p>
                  </div>
                  <div data-id="element-714" data-mp="223ho7qw3a16v">
                    <p className="text-zinc-300 leading-relaxed" data-id="element-715" data-mp="59ee6x0a4x61">
                      <strong className="text-white" data-id="element-716" data-mp="58lgsmn7nk0k">"Website"</strong> means
                      business.ari-os.com, api.business.ari-os.com;
                      marketplace.ari-os.com; developer.ari-os.com;
                      get-started.business.ari-os.com; launchpad.ari-os.com;
                      api.business.ari-os.com.
                    </p>
                  </div>
                </div>
              </section>

              {/* Section 1 */}
              <section data-id="element-717" data-mp="miyt2h84bd43">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-718" data-mp="mhe211l0icaz">
                  1. What is Our Role in Collecting and Processing Your Data?
                </h2>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-719" data-mp="3pyw5yxxnyz64">
                  Depending on how you access the Service, different parties may
                  act as data controller:
                </p>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-720" data-mp="3shd7d8dwc05">
                  1.1 Enterprise / Employer Deployments for Ari OS, including
                  Ari AI Assistant
                </h3>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-721" data-mp="1f63350m2ihmq">
                  If you use Ari OS, which includes Ari AI Assistant, as an
                  employee or contractor of an organization (for example, your
                  employer or enterprise business customer) that has subscribed
                  to a Ari OS, that organization is the data controller for your
                  use of Ari OS. We act as a data processor on their behalf and
                  process your Personal Data according to their documented
                  instructions and our data processing agreement with them.
                  Where there is any inconsistency, the privacy notice provided
                  by your organization prevails.
                </p>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-722" data-mp="2o19ahxar7bbg">
                  1.2 Direct / Self-Service Users for Ari OS
                </h3>
                <p className="text-zinc-300 leading-relaxed" data-id="element-723" data-mp="ymbgowv6oujc">
                  If you sign up and use any Service, directly with us (without
                  a business enterprise customer in between), we are the data
                  controller for your use of the Service.
                </p>
              </section>

              {/* Section 2 */}
              <section data-id="element-724" data-mp="2wijlehyaii0p">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-725" data-mp="2wh8lwubvnwfe">
                  2. What Data Do We Collect?
                </h2>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-726" data-mp="30h8x863ojri8">
                  2.1 We may collect and process Data when you use the Services
                  as follows:
                </h3>

                <h4 className="text-lg font-semibold text-white mb-3 mt-4" data-id="element-727" data-mp="2dj5pvvkwwz83">
                  2.1.1 Identification and Account Information
                </h4>
                <p className="text-zinc-300 leading-relaxed mb-3" data-id="element-728" data-mp="2hl9ellwle0bb">
                  In order to register, log on, or use Ari OS, the Ari Cloud
                  platform, Ari Business Cloud platform, Ari Marketplace, Ari
                  Web Portal or the Ari Companion App, we collect the following
                  information to facilitate access and to send notifications
                  and/or reports:
                </p>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-729" data-mp="1vdkjjbf6x422">
                  <li data-id="element-730" data-mp="1gks5upje43cl">Name, username, display name;</li>
                  <li data-id="element-731" data-mp="1lmzk5lrozvi3">
                    Contact details (for example, delivery address or email
                    address);
                  </li>
                  <li data-id="element-732" data-mp="299pncqfs1w4a">Company or/ organization name;</li>
                  <li data-id="element-733" data-mp="2e9amp1yv06hj">
                    Authentication and authorization data (for example, Single
                    Sign-On, ID tokens, roles); and
                  </li>
                  <li data-id="element-734" data-mp="24bo4a5icpwst">Any other details asked for and which you provide.</li>
                </ul>

                <h4 className="text-lg font-semibold text-white mb-3 mt-4" data-id="element-735" data-mp="ovfim64vlm3r">
                  2.1.2 When you conduct activities on our website
                </h4>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-736" data-mp="suxu6bat4ktx">
                  For example, when you purchase a product on our website, we
                  may collect your name, email, shipping and billing address,
                  payment details, company name, phone number, and other
                  information gathered by Shopify and transferred to us.
                </p>

                <h4 className="text-lg font-semibold text-white mb-3 mt-4" data-id="element-737" data-mp="qarre6xxj0ey">
                  2.1.3 Usage and Device Data
                </h4>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-738" data-mp="3tucjsiw358cp">
                  <li data-id="element-739" data-mp="cdl8mcd7h1pq">
                    Information about your AR device and/or your computer, and
                    about your visits to and use of the Service, such as device
                    identifiers, for example: AR device ID, browser/device type
                    and version, operating system);
                  </li>
                  <li data-id="element-740" data-mp="3b2k2hlqdpbkt">
                    Log data (timestamps, feature usage, performance metrics,
                    error logs); and
                  </li>
                  <li data-id="element-741" data-mp="8mwnmkobrt7w">
                    Approximate location based on IP address and provided by
                    your browser, the site from which you were directed, and the
                    links followed when leaving the Service (country/region
                    level, where necessary for security, routing and
                    compliance).
                  </li>
                </ul>

                <h4 className="text-lg font-semibold text-white mb-3 mt-4" data-id="element-742" data-mp="3ltewsi62o7po">
                  2.1.4 Support and Communication
                </h4>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-743" data-mp="3qrq7ev46ym8y">
                  <li data-id="element-744" data-mp="3vtpae3w0rh5d">
                    Information you provide when you contact support (email,
                    chat, ticket systems); and
                  </li>
                  <li data-id="element-745" data-mp="1b13ys5v7fcpt">
                    Feedback you provide, bug reports, and responses to customer
                    satisfaction surveys.
                  </li>
                </ul>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-746" data-mp="2qkbe2hcgh2l4">
                  2.2 We may collect and process the following Data when you use
                  the Ari AI Assistant included in the Service as follows:
                </h3>

                <h4 className="text-lg font-semibold text-white mb-3 mt-4" data-id="element-747" data-mp="2gsywcikdfsst">
                  2.2.1 Voice and Text Content
                </h4>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-748" data-mp="27ttub29lphbw">
                  <li data-id="element-749" data-mp="22v0lvo968gil">Voice input from your microphone (audio stream);</li>
                  <li data-id="element-750" data-mp="22x3hcnt3f1up">Transcriptions of your voice input;</li>
                  <li data-id="element-751" data-mp="1xxh268tpfbj9">
                    Text prompts, questions, commands and other content you send
                    to Ari; and
                  </li>
                  <li data-id="element-752" data-mp="3saghs1y345qj">
                    Outputs generated by the Ari AI Assistant (for example, text
                    responses).
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-753" data-mp="43nrkbvlqpmb">
                  Raw audio is generally processed in real time via our speech
                  provider(s). Whether we retain audio recordings depends on
                  your organization's configuration and applicable law (see
                  Retention, Section 7).
                </p>

                <h4 className="text-lg font-semibold text-white mb-3 mt-4" data-id="element-754" data-mp="3hitx9i4a1k94">
                  2.2.2 "Memories" and Conversation History
                </h4>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-755" data-mp="37mh20ft32yc9">
                  <li data-id="element-756" data-mp="3clbobrq9f514">
                    Conversation history (time, content of interactions); and
                  </li>
                  <li data-id="element-757" data-mp="2ylamoa267tkl">
                    Optional "memories" created by your use of Ari AI Assistant
                    about you (for example: your role, common tasks,
                    preferences, or context you provide and choose to save).
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-758" data-mp="2f0abrt1z6xtv">
                  You (or your administrator) can usually control whether
                  conversation history and memories are stored, and you may
                  delete them via the Ari AI Assistant platform where those
                  features are available.
                </p>

                <h4 className="text-lg font-semibold text-white mb-3 mt-4" data-id="element-759" data-mp="32vlf1xcjwenn">
                  2.2.3 Data from Integrations
                </h4>
                <p className="text-zinc-300 leading-relaxed mb-3" data-id="element-760" data-mp="3bqjfdpi12tp0">
                  If you or your organization connect Ari AI Assistant to
                  third-party systems, we may process Data from those systems,
                  such as:
                </p>
                <div className="ml-4 mb-4" data-id="element-761" data-mp="3lluqzyy53ksj">
                  <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-762" data-mp="3gq5r1ui7k1vp">
                    <strong className="text-white" data-id="element-763" data-mp="2ebygmvta0gd9">
                      Microsoft 365 / Microsoft Entra ID:
                    </strong>
                  </p>
                  <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-764" data-mp="2idjm3w3hdsdf">
                    <li data-id="element-765" data-mp="2nati5uldl2a8">
                      Emails, calendar entries, tasks, files, Teams
                      channels/messages, and contact details, to the extent you
                      or your organization have granted access.
                    </li>
                  </ul>
                  <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-766" data-mp="31zy3vlrdpon3">
                    <strong className="text-white" data-id="element-767" data-mp="362coobelyyh0">
                      Other Enterprise Systems:
                    </strong>
                  </p>
                  <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4" data-id="element-768" data-mp="3b16100i5sjfl">
                    <li data-id="element-769" data-mp="1bqecq1owzohf">
                      Documents, tickets, asset data, CRM data, knowledge bases
                      or similar, as configured by your organization.
                    </li>
                  </ul>
                </div>
                <p className="text-zinc-300 leading-relaxed" data-id="element-770" data-mp="14doxx4szzgzr">
                  The exact categories depend on the integration and permissions
                  granted by you through such third-party systems. Access scopes
                  are shown when you authorize the integration and can be
                  limited or withdrawn in the relevant third-party system.
                </p>
              </section>

              {/* Section 3 */}
              <section data-id="element-771" data-mp="1n5hoytoias4u">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-772" data-mp="1n23m7kbxkgwv">
                  3. What is Our Purpose and Legal Basis for Collecting Data?
                </h2>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-773" data-mp="1e2qael0c3g8z">
                  3.1 Providing and Operating the Service
                </h3>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-774" data-mp="2ocuc2bto53i">
                  <li data-id="element-775" data-mp="2qpfeocvmvks">
                    To authenticate you and provide you access to the Service;
                  </li>
                  <li data-id="element-776" data-mp="26spgkgt93g8s">
                    To process payments for products purchased on our website;
                  </li>
                  <li data-id="element-777" data-mp="1stq2u47a0lre">
                    To process your voice and text input and generate responses;
                  </li>
                  <li data-id="element-778" data-mp="1xrrisg9eo4yn">
                    To enable features such as conversation history, memories
                    and context retrieval; and
                  </li>
                  <li data-id="element-779" data-mp="2phdx6qkpazer">
                    To connect to third-party services for which you authorize
                    (for example, Microsoft 365 or Shopify when you purchase a
                    product).
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-780" data-mp="34fy8atjuhlj8">
                  <strong className="text-white" data-id="element-781" data-mp="34en5avy84ht6">Legal basis:</strong>
                </p>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-782" data-mp="3987r7pmjllc0">
                  <li data-id="element-783" data-mp="3ik5i1zi5dyvs">
                    Performance of a contract where we provide the Service
                    directly to you; and/or
                  </li>
                  <li data-id="element-784" data-mp="3sbt6drjeqzt1">
                    Legitimate business interests in order for your organization
                    to provide productivity and knowledge tools to its
                    workforce, and for us to provide and improve the Service.
                  </li>
                </ul>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-785" data-mp="2vliss89qci7m">
                  3.2 Personalization (History and Memories)
                </h3>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-786" data-mp="39m39myw343yh">
                  <li data-id="element-787" data-mp="34kdyzkcrxsax">
                    To remember relevant context across sessions (for example,
                    your role, preferences, ongoing tasks);
                  </li>
                  <li data-id="element-788" data-mp="juom3cvmsgkv">
                    To show previous conversations or references you have chosen
                    to keep; and
                  </li>
                  <li data-id="element-789" data-mp="1f1d3alwn0530">
                    To adjust Ari AI Assistant's behavior for your organization
                    or team (for example, domain-specific knowledge).
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-790" data-mp="1oz19c7zp0z0h">
                  <strong className="text-white" data-id="element-791" data-mp="22z2brrvlwei2">Legal basis:</strong>
                </p>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-792" data-mp="22wpjaks82lqr">
                  <li data-id="element-793" data-mp="1xxv1nm5zr388">Your consent; or</li>
                  <li data-id="element-794" data-mp="2cpdifm6od1sn">
                    Legitimate business interests in providing a more effective
                    and user‑friendly service, subject to your right to object
                    and/or disable such features.
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-795" data-mp="2gqgwc355wnr8">
                  You can typically turn off or clear history and memories in
                  the Ari AI Assistant settings, or via your administrator.
                </p>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-796" data-mp="35aahm3pckudw">
                  3.3 Security, Abuse Prevention and Service Quality
                </h3>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-797" data-mp="2vcw2c7f5ubn6">
                  <li data-id="element-798" data-mp="2hlravsly4pnx">
                    To protect the Service against misuse, fraud and security
                    incidents;
                  </li>
                  <li data-id="element-799" data-mp="2me282npaxxcs">To monitor, detect and fix technical issues; and</li>
                  <li data-id="element-800" data-mp="27ocuft00w0vm">
                    for Ari AI Assistant to generate technical logs and
                    telemetry (including, where enabled, traces of requests to
                    and from third-party AI infrastructure).
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-801" data-mp="23lq7o6i7l65a">
                  <strong className="text-white" data-id="element-802" data-mp="23o2lq8kuiwd2">Legal basis:</strong>
                </p>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-803" data-mp="972neuyu9zyt">
                  <li data-id="element-804" data-mp="4dhyrtj4yica">
                    Legitimate interests in maintaining the security and
                    reliability of the Service; and
                  </li>
                  <li data-id="element-805" data-mp="3rkk106e90v17">
                    Compliance with legal obligations, where we must maintain
                    certain logs.
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-806" data-mp="n5skialnrzn6">
                  Where optional, advanced logging or analytics is enabled, we
                  may ask for your consent or your organization may determine
                  the applicable legal basis.
                </p>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-807" data-mp="33u6c2oqyncau">
                  3.4 Product Improvement and Research
                </h3>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-808" data-mp="2ytietlc51z86">
                  <li data-id="element-809" data-mp="1eec6h8ym6364">
                    For internal record keeping and administrative purposes and
                    to communicate information about the Services and inform you
                    about our events, products, or other related information
                    that we think would be of interested to you;
                  </li>
                  <li data-id="element-810" data-mp="1x3ivfdq03r0d">
                    To communicate marketing messages, newsletters and details
                    of our business;
                  </li>
                  <li data-id="element-811" data-mp="221284971vvq7">
                    To analyze aggregated and/or pseudonymized usage patterns
                    (for example, which features are used, error rates);
                  </li>
                  <li data-id="element-812" data-mp="2b2rzjf0xmunz">
                    To understand how Ari AI Assistant performs across devices
                    and environments; and
                  </li>
                  <li data-id="element-813" data-mp="goinf15cl0c6">
                    For statistical purposes and analysis for management
                    purposes in order to administer the website and to develop
                    and test new features and improve our products and services.
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-814" data-mp="3rixr36itshzc">
                  We do not use identifiable conversation content to train
                  publicly available third‑party foundation models. Where we use
                  Data to train or fine‑tune models for a specific customer,
                  this is done under that customer's instructions and
                  customer-specific contracts. We do not use automated
                  decision-making.
                </p>
                <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-815" data-mp="33slehicmxx2f">
                  <strong className="text-white" data-id="element-816" data-mp="33raapij6wpbb">Legal basis:</strong>
                </p>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-817" data-mp="2g1fz14alx6sn">
                  <li data-id="element-818" data-mp="2b460mz58pkso">
                    Legitimate business interests to improve the Service, using
                    Data in a way that minimizes privacy risks (for example,
                    aggregation, pseudonymization); and/or
                  </li>
                  <li data-id="element-819" data-mp="hmqijz49tzea">
                    Your consent (where required by law or your organization's
                    policies.
                  </li>
                </ul>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-820" data-mp="19d4sjk95yrko">
                  3.5 Compliance and Legal Claims
                </h3>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-821" data-mp="1ebg1lsrmwy1u">
                  <li data-id="element-822" data-mp="10bf2ahr0pyoh">
                    To comply with legal obligations (for example, tax,
                    accounting, regulatory orders); and
                  </li>
                  <li data-id="element-823" data-mp="3l25zzlezbb9g">To establish, exercise or defend legal claims.</li>
                </ul>
                <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-824" data-mp="3q21vew9m1ude">
                  <strong className="text-white" data-id="element-825" data-mp="3pz5xh7xrj5oy">Legal basis:</strong>
                </p>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4" data-id="element-826" data-mp="1vnegm090fgeb">
                  <li data-id="element-827" data-mp="1qmz6rinxsr13">Compliance with legal obligations; and</li>
                  <li data-id="element-828" data-mp="1lupcjqfsh4t0">
                    Legitimate business interests in managing and defending
                    legal claims.
                  </li>
                </ul>
              </section>

              {/* Section 4 */}
              <section data-id="element-829" data-mp="1cw3v5ym1zvtt">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-830" data-mp="1csg2f1ofndg5">
                  4. Cookies and Similar Technologies
                </h2>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-831" data-mp="12xo23q3gucho">
                  If you use the Ari Website we may use cookies or similar
                  technologies:
                </p>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-832" data-mp="2xaxgnwavco6s">
                  <li data-id="element-833" data-mp="2t8izrhqrfyi5">
                    Strictly necessary cookies to operate the Service (for
                    example, session management, security); and
                  </li>
                  <li data-id="element-834" data-mp="k04dv2u778q3">
                    Optional cookies or technologies (if used) for analytics or
                    feature enhancements.
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-835" data-mp="ssogeedm1xg7">
                  Generally, we set cookies to analyze user interest in our
                  website and help you navigate our website and make it more
                  user-friendly. Some cookies remain stored on your device until
                  you delete them. They allow us to recognize your browser the
                  next time you visit our website. However, if you do not want
                  this, you can set up your browser so that it informs you about
                  the setting of cookies and you allow this only in individual
                  cases. Disabling cookies may limit the functionality of our
                  website. Where required by law, we will ask for your consent
                  before placing non‑essential cookies. For example, if you
                  don't want to us to make automated marketing decisions based
                  on your preferences, then uncheck the marketing box prior to
                  submitting a request. If you'd like to opt out later, please
                  contact support@realwear.com.
                </p>
              </section>

              {/* Section 5 */}
              <section data-id="element-836" data-mp="1awgc7obt106z">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-837" data-mp="1av4zgz0dsi3q">
                  5. How We Share Your Data?
                </h2>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-838" data-mp="1ov69p52jd1vv">
                  We employ Data Processors to process the information that we
                  use for our own legitimate business purposes - for instance we
                  use Azure Marketplace, Google and HubSpot to market our goods
                  and services to you.
                </p>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-839" data-mp="3civab5enzsci">
                  We may share your Data with third parties the following
                  categories of recipients, strictly on a need‑to‑know basis:
                </p>

                <div className="space-y-4 ml-4" data-id="element-840" data-mp="32pwizfrs9np7">
                  <div data-id="element-841" data-mp="37qagw4zo7h9i">
                    <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-842" data-mp="37piwlqbix5yj">
                      <strong className="text-white" data-id="element-843" data-mp="2stjq2k42bdvi">
                        Your organization (enterprise customers):
                      </strong>
                    </p>
                    <p className="text-zinc-300 leading-relaxed ml-4" data-id="element-844" data-mp="2jtejudalulix">
                      If you use the Service through your organization, certain
                      administrators or authorized personnel may access usage
                      information, logs and configuration data, in line with
                      your organization's policies.
                    </p>
                  </div>

                  <div data-id="element-845" data-mp="1osr86d9xdl9g">
                    <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-846" data-mp="1otk74s2n76h1">
                      <strong className="text-white" data-id="element-847" data-mp="1trc6u89j3wvs">
                        AI infrastructure and cloud providers:
                      </strong>
                    </p>
                    <p className="text-zinc-300 leading-relaxed ml-4 mb-2" data-id="element-848" data-mp="1yolxtsckgglq">
                      For example:
                    </p>
                    <ul className="list-disc list-inside text-zinc-300 space-y-1 ml-8" data-id="element-849" data-mp="27jief5ym8vjm">
                      <li data-id="element-850" data-mp="2chto9gowv61u">Speech‑to‑text providers;</li>
                      <li data-id="element-851" data-mp="2cg8s5mmy7f1v">Large language model providers;</li>
                      <li data-id="element-852" data-mp="2hgwuv5kjhkbx">Text‑to‑speech providers;</li>
                      <li data-id="element-853" data-mp="2hfbxz9ar5paw">
                        Hosting and database providers (for example, managed
                        PostgreSQL); and
                      </li>
                      <li data-id="element-854" data-mp="n4q777aglb2q">Logging and observability platforms.</li>
                    </ul>
                    <p className="text-zinc-300 leading-relaxed ml-4 mt-2" data-id="element-855" data-mp="s31g9fsxjhjw">
                      These providers process your Data solely to deliver their
                      services to us, under data processing agreements.
                    </p>
                  </div>

                  <div data-id="element-856" data-mp="2wjergd7z2oo1">
                    <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-857" data-mp="2wkzihsv2vph5">
                      <strong className="text-white" data-id="element-858" data-mp="2rlwfedynrtbt">HubSpot</strong>
                    </p>
                    <p className="text-zinc-300 leading-relaxed ml-4" data-id="element-859" data-mp="3obvwiwsvk060">
                      This website uses HubSpot, an Inbound Marketing platform
                      offered by HubSpot, Inc. HubSpot uses "cookies" and forms
                      to help the website analyze how it is used by visitors.
                      The information generated by the cookie about your use of
                      the website (with the inclusion of your IP address) is
                      transferred to and stored by HubSpot on servers in the
                      United States. HubSpot says it is compliant with the EU-US
                      Privacy Shield Framework. HubSpot uses this information to
                      keep track of how you use the website, produce reports on
                      the website activity for website operators and to offer
                      other services with respect to website activities and
                      Internet use. HubSpot is permitted to transmit this
                      information to third parties if HubSpot is required to do
                      by law, or if these third parties process the information
                      on behalf of HubSpot. HubSpot will not combine your IP
                      address with other data in its possession. Further
                      information about HubSpot's privacy policy may be obtained
                      from:{' '}
                      <a href="https://legal.hubspot.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#8846DE] hover:text-[#E9A165] transition-colors" data-id="element-860" data-mp="yorgifjcwg3h">
                        https://legal.hubspot.com/privacy-policy
                      </a>
                      .
                    </p>
                  </div>

                  <div data-id="element-861" data-mp="tzqa6z72b2d5">
                    <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-862" data-mp="u003avnelpn2">
                      <strong className="text-white" data-id="element-863" data-mp="p0n7vmigva8v">Google Analytics</strong>
                    </p>
                    <p className="text-zinc-300 leading-relaxed ml-4" data-id="element-864" data-mp="130eolv0db4qk">
                      This website uses Google Analytics, a web analytics
                      service provided by Google, Inc. ("Google"). The
                      information generated by the cookie about your use of our
                      website (including your IP address) will be transmitted to
                      and stored by Google on servers in the United States.
                      Google will use this information for the purpose of
                      evaluating your user of our website, compiling reports on
                      website activity for website operators and providing other
                      services relating to website activity and internet usage.
                      Google may also transfer this information to third parties
                      where required to do so by law, or where such third
                      parties process the information on Google's behalf. Google
                      will not associate your IP address with any other data
                      held by Google. Further information about Google's privacy
                      policy may be obtained from:{' '}
                      <a href="http://www.google.com/privacy.html" target="_blank" rel="noopener noreferrer" className="text-[#8846DE] hover:text-[#E9A165] transition-colors" data-id="element-865" data-mp="326tssy8e1ie7">
                        http://www.google.com/privacy.html
                      </a>
                      .
                    </p>
                  </div>

                  <div data-id="element-866" data-mp="lh4ucbecghv7">
                    <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-867" data-mp="lksn38byt08v">
                      <strong className="text-white" data-id="element-868" data-mp="2608nrey0bfjs">
                        Integration partners
                      </strong>
                    </p>
                    <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4" data-id="element-869" data-mp="1x86sdv2sopgd">
                      <li data-id="element-870" data-mp="1s9da7pckca9v">
                        When you connect Ari AI Assistant to third‑party systems
                        (for example, Microsoft 365), we will share and receive
                        data with/from those systems according to the
                        permissions you or your organization grant there;
                      </li>
                      <li data-id="element-871" data-mp="1ea45pmxpz4lq">
                        When you connect to our website to purchase products,
                        our web shop is operated by Shopify for you to make an
                        online purchase. You can find information on how Shopify
                        processes your Data when you purchase a product through
                        Shopify's own privacy policy, which is available here:{' '}
                        <a href="https://www.shopify.com/legal/privacy" target="_blank" rel="noopener noreferrer" className="text-[#8846DE] hover:text-[#E9A165] transition-colors" data-id="element-872" data-mp="3mrat4ggue22x">
                          https://www.shopify.com/legal/privacy
                        </a>
                        ; and
                      </li>
                      <li data-id="element-873" data-mp="ab7aj01uakca">
                        When we ship products to you through a shipping partner,
                        those shipping partners' privacy policies apply and can
                        be found as follows: USPS, Royal Mail, UPS, FedEx, and
                        DHL.
                      </li>
                    </ul>
                  </div>

                  <div data-id="element-874" data-mp="5egq60j052l2">
                    <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-875" data-mp="2l38os6i9a4ew">
                      <strong className="text-white" data-id="element-876" data-mp="2l64nhx1xgx4e">
                        Professional advisers and authorities
                      </strong>
                    </p>
                    <p className="text-zinc-300 leading-relaxed ml-4" data-id="element-877" data-mp="2ihsobe2ftdtt">
                      Where necessary, we may share Data with auditors, legal
                      advisors, or public authorities (for example, courts,
                      regulators) if we are legally required to do so.
                    </p>
                  </div>
                </div>

                <p className="text-zinc-300 leading-relaxed mt-4" data-id="element-878" data-mp="1yul7l9ltnwck">
                  We do not sell your Personal Data.
                </p>
              </section>

              {/* Section 6 */}
              <section data-id="element-879" data-mp="28lftgcv5otxh">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-880" data-mp="28lxxvwrz2egh">
                  6. Where is Data Processed or Controlled?
                </h2>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-881" data-mp="1g4vbmj6bp4j2">
                  We are a U.S. company and we process your information with the
                  same level of care and security that the European Union
                  requires. We process your Data in the US and potentially
                  internationally as some of our service providers and
                  infrastructure may be located in countries outside the
                  European Economic Area (EEA), the United Kingdom, or
                  Switzerland, including countries that may not provide the same
                  level of data protection as your home country.
                </p>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-882" data-mp="19gqa1xstrty6">
                  Where we transfer Personal Data to such countries, we use:
                </p>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-883" data-mp="1icfqrtjbw058">
                  <li data-id="element-884" data-mp="1n965acfhinoj">
                    The EU–US Data Privacy Framework, UK–US Data Bridge, and
                    Swiss-US Data Privacy Policy Framework, where applicable.
                  </li>
                  <li data-id="element-885" data-mp="1x9gj9z9cfz4r">
                    Other appropriate legal mechanisms, such as Standard
                    Contractual Clauses (SCCs) approved by the European
                    Commission, the UK Information Commissioner's Office, or the
                    Swiss Federal Data Protection and Information Commissioner.
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed" data-id="element-886" data-mp="32tf6jnfaikgc">
                  You can contact us for more information about international
                  transfers and copies of relevant safeguards (subject to
                  redactions to protect confidentiality).
                </p>
              </section>

              {/* Section 7 */}
              <section data-id="element-887" data-mp="3qpjkh3ry3axj">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-888" data-mp="3qorm5l6yqz3k">
                  7. Data Retention
                </h2>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-889" data-mp="n1rdw47b7e3c">
                  We retain Personal Data only for as long as necessary for the
                  purposes described in this Privacy Policy or as required by
                  law. Retention periods may vary based on the settings of your
                  organization and the nature of the data. By default, we apply
                  the following principles (subject to configuration):
                </p>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-890" data-mp="23x6gdsz91nx1">
                  <li data-id="element-891" data-mp="1yydb2nu4937y">
                    Account data: kept for the duration of your account or
                    contract, plus a reasonable period (for example, up to 3
                    years) where required for legal obligations or dispute
                    resolution.
                  </li>
                  <li data-id="element-892" data-mp="1l2hyezqb8od0">
                    Conversation history: kept until you or your organization
                    delete them, or the account is closed, subject to backup
                    cycles.
                  </li>
                  <li data-id="element-893" data-mp="3af3btrfrt2u6">
                    Memories: kept until you or your organization delete them,
                    or the account is closed, subject to backup cycles.
                  </li>
                  <li data-id="element-894" data-mp="3mxp6i0zi20jp">
                    Technical logs and telemetry: kept until you or your
                    organization delete them, or the account is closed, subject
                    to backup cycles.
                  </li>
                  <li data-id="element-895" data-mp="hb94vitd3bs">
                    Backups: stored securely for up to 90 days before they are
                    overwritten, after which deleted data will no longer appear
                    in any backups.
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed" data-id="element-896" data-mp="38xwjogr3g4h0">
                  If you request deletion of your Data, we will implement it in
                  our active systems and ensure that the data will not be
                  restored from backups once those automatically expire, except
                  where retention is required by law or by our contracts with
                  your organization.
                </p>
              </section>

              {/* Section 8 */}
              <section data-id="element-897" data-mp="3uph2a0rkmevw">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-898" data-mp="3uq8o4jvd8y8z">
                  8. Security
                </h2>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-899" data-mp="dg0xegvd32fo">
                  We take appropriate technical and organizational measures to
                  protect Personal Data, including:
                </p>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-900" data-mp="3gyc28xkajkl1">
                  <li data-id="element-901" data-mp="3c0iy0a2jt0ne">Encryption in transit and at rest, where appropriate;</li>
                  <li data-id="element-902" data-mp="3qox732qk5lce">
                    Role‑based access control and least‑privilege principles;
                  </li>
                  <li data-id="element-903" data-mp="3lvucqsdyi7v5">Separation of production and test environments;</li>
                  <li data-id="element-904" data-mp="2y6j8v21b7xcs">Logging and monitoring of access and activities;</li>
                  <li data-id="element-905" data-mp="2t8zv038ixmld">Regular backups and tested recovery procedures;</li>
                  <li data-id="element-906" data-mp="2t6nd1q2rnc8b">Staff training and confidentiality obligations; and</li>
                  <li data-id="element-907" data-mp="18p4igocgajne">
                    Vendor review and contractual safeguards for our processors
                    and sub‑processors.
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed" data-id="element-908" data-mp="ytue3tyky06g">
                  No system is completely secure, but we work continuously to
                  keep the Service protected. If we become aware of a Personal
                  Data breach that may pose a high risk to your rights and
                  freedoms, we will notify you and/or the relevant controller
                  and authorities as required by law.
                </p>
              </section>

              {/* Section 9 */}
              <section data-id="element-909" data-mp="1mg9ab49ku7n6">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-910" data-mp="1mjoqybiwfoqp">
                  9. Your Rights
                </h2>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-911" data-mp="b2f9tvn8t8sk">
                  You may have the following rights in relation to your Personal
                  Data:
                </p>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-912" data-mp="mj3elfmaz1hj">
                  <li data-id="element-913" data-mp="mha7y0bowh9j">
                    Right of access – to request copies of your Personal Data
                    from us, and depending on what you would like to have
                    copied, we may charge you a small fee for this service;
                  </li>
                  <li data-id="element-914" data-mp="1a7wcviqedlfb">
                    Right to rectification – to correct Data you believe is
                    inaccurate or incomplete;
                  </li>
                  <li data-id="element-915" data-mp="109glrfrdec5t">
                    Right to erasure – to request deletion of your Personal Data
                    in certain circumstances, to the extent allowed by law;
                  </li>
                  <li data-id="element-916" data-mp="3l1s33e03xn9v">
                    Right to restriction – to request that we restrict
                    processing of your Data in certain circumstances, such as
                    for marketing purposes;
                  </li>
                  <li data-id="element-917" data-mp="1wf06e3yuig5u">
                    Right to data portability – to receive your Data in a
                    structured, commonly used, machine‑readable format and
                    transmit it to another controller where technically
                    feasible;
                  </li>
                  <li data-id="element-918" data-mp="2aakpazekqyd9">
                    Right to object – to object to processing your Data based on
                    our legitimate interests, including profiling, and to opt
                    out of certain uses of your Data; and
                  </li>
                  <li data-id="element-919" data-mp="2o9bvlzn73fqu">
                    Right to withdraw consent –you may withdraw it at any time
                    by providing notice to Ari as set out in Section 12 below.
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-920" data-mp="tw2lq6qqls82">
                  For enterprise customers as set out in Section 1.1 above, in
                  order to exercise your rights, please contact your
                  organization directly.
                </p>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-921" data-mp="1x6gr5nk6cw65">
                  As a direct user as set out in Section 1.2 above, to exercise
                  your rights, please contact us using the details in Section 12
                  below. We may ask you for additional information to verify
                  your identity. If you make a request we have thirty (30) days
                  to respond to you, or as otherwise required by law.
                </p>
                <p className="text-zinc-300 leading-relaxed" data-id="element-922" data-mp="2tvxsjqc4jw21">
                  You also have the right to lodge a complaint with a
                  supervisory authority, in particular in the EU/EEA Member
                  State, the UK, or Switzerland where you live, work, or where
                  you believe your rights have been infringed.
                </p>
              </section>

              {/* Section 10 */}
              <section data-id="element-923" data-mp="3ihm0par564vf">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-924" data-mp="3ie7yq3me3xoi">
                  10. Children
                </h2>
                <p className="text-zinc-300 leading-relaxed" data-id="element-925" data-mp="38i4yj3b3m947">
                  Ari is not intended for children under 16 years of age and we
                  do not knowingly collect Personal Data from children under
                  this age. If we become aware that we have collected such Data,
                  we will take steps to delete it.
                </p>
              </section>

              {/* Section 11 */}
              <section data-id="element-926" data-mp="2psesfk1vy0wz">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-927" data-mp="2psy96xfsuj9f">
                  11. Changes to This Privacy Policy
                </h2>
                <p className="text-zinc-300 leading-relaxed" data-id="element-928" data-mp="2uodqjzd0mxal">
                  We may update this Privacy Policy from time to time, for
                  example to reflect changes in our Service or legal
                  requirements. We will post the updated version and change the
                  "Last updated" date at the top. If changes are material, we
                  will take additional steps to inform you, such as in‑app
                  notifications.
                </p>
              </section>

              {/* Section 12 */}
              <section data-id="element-929" data-mp="2m9r62ykoticb">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-930" data-mp="2maj0i62jta10">
                  12. Company and Contact Information
                </h2>
                <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-931" data-mp="2diqpnu9m3yvw">
                  If you have questions or concerns about this Privacy Policy or
                  our data practices, you can contact us at:
                </p>
                <ul className="list-disc list-inside text-zinc-300 space-y-2 ml-4 mb-4" data-id="element-932" data-mp="23lcg8em3wad3">
                  <li data-id="element-933" data-mp="1yk54k4guer15">
                    RealWear, Inc. dba Ari, a Washington corporation located at
                    600 Hatheway Rd #206, Vancouver, WA 98661, United States.
                  </li>
                  <li data-id="element-934" data-mp="a0iv044ngbq7">
                    Email:{' '}
                    <a href="mailto:legal@realwear.com" className="text-[#8846DE] hover:text-[#E9A165] transition-colors" data-id="element-935" data-mp="e35qcf0j4es5">
                      legal@realwear.com
                    </a>
                  </li>
                </ul>
                <p className="text-zinc-300 leading-relaxed mb-2" data-id="element-936" data-mp="o1lhghzk3o1n">
                  <strong className="text-white" data-id="element-937" data-mp="3miz78uyrvs9q">
                    For California Residents:
                  </strong>
                </p>
                <p className="text-zinc-300 leading-relaxed" data-id="element-938" data-mp="3rj3myiruwiyw">
                  Under California Civil Code Section 1798.83 (also known as
                  S.B. 27), if You are a California resident and Your business
                  relationship with RealWear is primarily for personal, family,
                  or household purposes, You may request certain data regarding
                  Ari's disclosure, if any, of Personal Data to third parties
                  for the third-party's direct marketing purposes. To make such
                  a request, please contact legal@realwear.com; You may make
                  such a request up to once per calendar year. If applicable, we
                  will provide You, by e-mail, a list of the categories of
                  Personal Data disclosed to third parties for their direct
                  marketing purposes; if applicable, during the immediately
                  preceding calendar year, along with the third parties' names
                  and addresses. Please note that not all Personal Data sharing
                  is covered by S.B. 27's requirements.
                </p>
              </section>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="border-t border-white/10 py-16 px-6" data-id="element-939" data-mp="1upq2m09ydji1">
          <div className="max-w-7xl mx-auto" data-id="element-940" data-mp="1gstg2b0vao6y">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-941" data-mp="1lr4p4jjc8uo4">
              <div className="flex items-center space-x-3" data-id="element-942" data-mp="125kz0tkvnon2">
                <img src="https://cdn.magicpatterns.com/uploads/3vCu7oKxcfkEiVUzGfZBCk/Ari_Logo_White.png" alt="Ari OS" className="h-8" data-id="element-943" data-mp="1264fs6ysk6zi" />
              </div>
              <div className="flex flex-col items-center md:items-end gap-2" data-id="element-944" data-mp="1b6skgb2aouzq">
                <p className="text-gray-400 text-center md:text-right" data-id="element-945" data-mp="174p69eo8rcar">
                  © 2025 AriOS created by RealWear. All rights reserved.
                </p>
                <div className="flex items-center gap-3 text-sm text-gray-400" data-id="element-946" data-mp="1l2vtm0vkdtw6">
                  <a href="https://support.realwear.com/hubfs/Ari/ari_terms_of_use_realwear.pdf" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-947" data-mp="1g4kmvz0kfzi6">
                    Terms of Use
                  </a>
                  <span data-id="element-948" data-mp="1pxjdfmfmi04f">|</span>
                  <a href="/conditions" className="hover:text-white transition-colors" data-id="element-949" data-mp="23uezcfgz3m1w">
                    Conditions
                  </a>
                  <span data-id="element-950" data-mp="1yxg3nshnv71l">|</span>
                  <a href="https://support.realwear.com/hubfs/Ari/ari_privacy_policy_realwear.pdf" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-951" data-mp="wiflpqly4rzy">
                    Privacy Policy
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>

      <style data-id="element-952" data-mp="1aavp4sires1e">{`
        @keyframes pulse-slow {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.05); }
        }
        
        .animate-pulse-slow {
          animation: pulse-slow 8s ease-in-out infinite;
        }
      `}</style>
    </div>;
}